(() => {
  const initTrustbadgeCartOffset = () => {
    const drawer = document.getElementById('CartDrawer')
    if (!drawer || drawer.dataset.hgTrustbadgeOffsetReady === 'true') return

    drawer.dataset.hgTrustbadgeOffsetReady = 'true'

    const root = document.documentElement
    let animationFrame = 0
    let observedFooter = null

    const resizeObserver =
      'ResizeObserver' in window
        ? new ResizeObserver(() => scheduleUpdate())
        : null

    const updateOffset = () => {
      animationFrame = 0

      const badgeButton = document.querySelector(
        '[id^="trustbadge-container-"] [data-testid="minimized-trustbadge-floating"]'
      )
      const badgeWrapper = badgeButton?.parentElement

      if (badgeWrapper) {
        badgeWrapper.classList.add('hg-trustbadge-cart-wrapper')
      }

      const isOpen = drawer.classList.contains('is-opened')
      document.body.classList.toggle('hg-cart-drawer-open', isOpen)

      if (!isOpen) {
        root.style.removeProperty('--hg-trustbadge-cart-bottom')
        return
      }

      const footer = drawer.querySelector('.cart-drawer__footer')
      if (!footer) return

      if (resizeObserver && footer !== observedFooter) {
        if (observedFooter) resizeObserver.unobserve(observedFooter)
        resizeObserver.observe(footer)
        observedFooter = footer
      }

      const badgeHeight = badgeButton?.getBoundingClientRect().height || 156
      const footerTop = Math.max(0, footer.getBoundingClientRect().top)
      const desiredBottom = window.innerHeight - footerTop + 16
      const minimumBottom = 190
      const maximumBottom = Math.max(16, window.innerHeight - badgeHeight - 12)
      const safeBottom = Math.min(
        Math.max(desiredBottom, minimumBottom),
        maximumBottom
      )

      root.style.setProperty(
        '--hg-trustbadge-cart-bottom',
        `${Math.round(safeBottom)}px`
      )
    }

    const scheduleUpdate = () => {
      if (animationFrame) cancelAnimationFrame(animationFrame)
      animationFrame = requestAnimationFrame(updateOffset)
    }

    new MutationObserver(scheduleUpdate).observe(drawer, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true,
    })

    new MutationObserver(() => {
      if (
        drawer.classList.contains('is-opened') ||
        !document.querySelector('.hg-trustbadge-cart-wrapper')
      ) {
        scheduleUpdate()
      }
    }).observe(document.body, {
      childList: true,
      subtree: true,
    })

    resizeObserver?.observe(drawer)
    window.addEventListener('resize', scheduleUpdate, { passive: true })
    scheduleUpdate()
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTrustbadgeCartOffset, {
      once: true,
    })
  } else {
    initTrustbadgeCartOffset()
  }
})()
